export const searchFormOption = function () {
    return [
        {
            prop: 'keyword',
            label: '关键字',
            type: 'input',
            placeholder: '请输入车架号/车牌号',
            width: '20%'
        },
        {
            prop: 'orgNo',
            label: '出单机构',
            type: 'cascader',
            placeholder: '请选择内容',
            propConfig: {
                children: 'children',
                label: 'orgName',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
            },
            options: this.$store.state.app.orgList,
            width: '20%'
        },
        {
            prop: 'saleNo',
            label: '业务员',
            type: 'select',
            width: '20%',
            options: this.$store.state.app.salesmanList
        },
        {
            prop: 'status',
            label: '状态',
            type: 'select',
            width: '20%',
            options: this.$emun.status
        },

    ]
}

// 设置折扣option
export const discountFormOption = function() {
    return [
      {
        prop: 'contractFee',
        label: '标准内保费',
        type: 'input',
        disabled: true,
        placeholder: '请输入内容'
      },
      {
        prop: 'customerRebate',
        label: '客户折扣',
        type: 'select',
        placeholder: '请输入折扣',
		options: [
			{'label':'0.5','value':'0.5'},
			{'label':'0.6','value':'0.6'},
			{'label':'0.7','value':'0.7'},
			{'label':'0.8','value':'0.8'},
			{'label':'0.9','value':'0.9'},
			{'label':'1.0','value':'1.0'},
			{'label':'1.1','value':'1.1'},
			{'label':'1.2','value':'1.2'},
			{'label':'1.3','value':'1.3'},
		]
      },
      {
        prop: 'cusFee',
        label: '客户内保费',
        type: 'input',
        // disabled: true,
        placeholder: '请输入内容'
      },
    ]
  }

export const InfoOption = function() {
  return [
    {
      prop: 'carNo',
      label: '车牌号码',
    },
    {
      prop: 'z_personName',
      label: '车主',
    },
    {
      prop: 'brandType',
      label: '品牌型号',
    },
    {
      prop: 'b_personName',
      label: '被内保人',
    },
    
    {
      prop: 'vin',
      label: '车架号',
    },
    {
      prop: 'beginDate',
      label: '初登日期',
    },
    {
      prop: 'carType',
      label: '车辆种类',
    },
    {
      prop: 'passengerCount',
      label: '载客人数',
    },
    // {
    //   prop: 'accidentType',
    //   label: '历年状态',
    // },
    {
      prop: 'planTime',
      label: '内保期限',
      width: '100%'
    },
  ]
}

export default {}